import { Modal } from "@mui/material";
import Styles from "./ViewProfile.module.css";
import { Close } from "@mui/icons-material";

const ViewProfile = ({ open, handleClose, data }) => {
  // const connectionStatus = normalizeStatus(connectionStatusRaw);
  const allowedStatuses = new Set([
    "ONGOING",
    "TERMS_INITIATED",
    "TERMS_ACCEPTED",
    "APPROVED",
  ]);
  const showCompanyName = allowedStatuses.has(data?.status);

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.modalHeading}`}
          >
            <div className="headingText">
              Profile
              <span className={Styles.headerName}>{data?.name}</span>
            </div>
            <Close
              style={{ fontSize: 24, color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div
            className={`display_flex_row_center ${Styles.profileDetailsSection}`}
          >
            <div className={Styles.companyInformation}>
              <div className={Styles.companyHeader}>
                <span>Company Information</span>
              </div>
              <div className={Styles.companyBottomPart}>
                <div
                  className={`${Styles.companyDetailsPart} ${
                    !showCompanyName ? Styles.blurred : ""
                  }`}
                >
                  <span>Company Name</span>
                  <span>
                    {showCompanyName
                      ? data?.companyDetails?.displayName ?? "***********"
                      : "NA"}
                  </span>
                </div>
                <div className={Styles.companyDetailsPart}>
                  <span>City</span>
                  <span>{data?.companyDetails?.city ?? "NA"}</span>
                </div>
                <div className={Styles.companyDetailsPart}>
                  <span>State</span>
                  <span>{data?.companyDetails?.state ?? "NA"}</span>
                </div>
                <div className={Styles.companyDetailsPart}>
                  <span>Credit Rating</span>
                  <span>{data?.companyDetails?.creditRating ?? "NA"}</span>
                </div>
                <div className={Styles.companyDetailsPart}>
                  <span>Credit Rating Year</span>
                  <span>{data?.companyDetails?.creditRatingYear ?? "NA"}</span>
                </div>
                <div className={Styles.companyDetailsPart}>
                  <span>Credit Rating Agency</span>
                  <span>
                    {data?.companyDetails?.creditRatingAgency ?? "NA"}
                  </span>
                </div>
              </div>
            </div>

            <div className={Styles.companyInformation}>
              <div className={Styles.companyHeader}>
                <span>Discom Information</span>
              </div>
              <div className={Styles.discomBottomPart}>
                <div
                  className={`${Styles.companyDetailsPart} ${
                    !showCompanyName ? Styles.blurred : ""
                  }`}
                >
                  <span>Specification</span>
                  <span>
                    {showCompanyName
                      ? data?.companyDetails?.discomName ?? "***********"
                      : "NA"}
                  </span>
                </div>
                <div className={Styles.companyDetailsPart}>
                  <span style={{ width: "100%" }}>Voltage Level</span>
                  <span>
                    {data?.companyDetails?.voltageLevels &&
                    data.companyDetails.voltageLevels.length > 0
                      ? data.companyDetails.voltageLevels.join(", ")
                      : "NA"}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`display_flex_row_center ${Styles.buttonMainContainer}`}
          >
            <div className={Styles.cancelBankButton} onClick={handleClose}>
              Cancel
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ViewProfile;
